<app-header></app-header>

<main>
  <div class="container text-center mb-4">
    <img src="assets/images/header.png" alt="Titulo" class="title-img" />
  </div>

  <section>
    <router-outlet></router-outlet>
  </section>
</main>

<app-footer></app-footer>
